import apiClient from "./apiClient";
import { CreateBookingRequest } from "../models/RequestModels/CreateBookingRequest";
import { UpdateBookingRequest } from "../models/RequestModels/UpdateBookingRequest";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { BookingResponse } from "../models/ResponseModels/BookingResponse";

interface GetBookingsParams {
  from?: string;
  until?: string;
  unit_id?: number;
  status?: string;
  source?: string;
}

interface CancelBookingResponse {
  message: string;
  data: BookingResponse;
}

export const getBookingsRequest = async (
  params?: GetBookingsParams,
): Promise<ApiCollectionResponse<BookingResponse>> => {
  const response = await apiClient.get<ApiCollectionResponse<BookingResponse>>(
    "/bookings",
    { params },
  );

  return response.data;
};

export const getBookingRequest = async (
  id: number,
): Promise<ApiSingleResponse<BookingResponse>> => {
  const response = await apiClient.get<ApiSingleResponse<BookingResponse>>(
    `/bookings/${id}`,
  );

  return response.data;
};

export const createBookingRequest = async (
  body: CreateBookingRequest,
): Promise<ApiSingleResponse<BookingResponse>> => {
  const response = await apiClient.post<ApiSingleResponse<BookingResponse>>(
    "/bookings",
    body,
  );

  return response.data;
};

export const updateBookingRequest = async (
  id: number,
  body: UpdateBookingRequest,
): Promise<ApiSingleResponse<BookingResponse>> => {
  const response = await apiClient.put<ApiSingleResponse<BookingResponse>>(
    `/bookings/${id}`,
    body,
  );

  return response.data;
};

export const cancelBookingRequest = async (
  id: number,
): Promise<CancelBookingResponse> => {
  const response = await apiClient.delete<CancelBookingResponse>(
    `/bookings/${id}`,
  );

  return response.data;
};

export const sendBookingInvoiceRequest = async (
  id: number,
): Promise<{ message: string }> => {
  const response = await apiClient.post<{ message: string }>(
    `/bookings/${id}/send-invoice`,
  );

  return response.data;
};
